import { Controller } from '@hotwired/stimulus';

/** Opens the sign-in / membership dialog when guests tap the roadmap vote button. */
export default class extends Controller {
  static targets = ['dialog'];

  open(event) {
    event?.preventDefault();
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close();
    }
  }
}
